export enum HeaderOptionsEnum {
  'more' = 'more',
  'scheduled' = 'scheduled',
  'open' = 'open',
  'in-progress' = 'in-progress',
  'waiting' = 'waiting',
  'done' = 'done',
  'delivered' = 'delivered',
  'canceled' = 'canceled',
  'consolidate' = 'consolidate',
  'display' = 'display',
  'signout' = 'signout',
}
